var React = require('react');

function LinkedInFilledInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2 8.5h5v14H2v-14zM2 4c0 .663.261 1.299.726 1.768a2.47 2.47 0 003.508 0 2.51 2.51 0 000-3.536 2.47 2.47 0 00-3.508 0A2.51 2.51 0 002 4zM18.5 22.5h3a.5.5 0 00.5-.5v-8.4C22 9.83 19.87 8 16.89 8a4.21 4.21 0 00-3.17 1.27A.41.41 0 0113 9a.5.5 0 00-.5-.5h-3A.5.5 0 009 9v13a.5.5 0 00.5.5h3a.5.5 0 00.5-.5v-7.5a2.5 2.5 0 015 0V22a.5.5 0 00.5.5z","fill":"currentColor"}));
}

LinkedInFilledInline.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = LinkedInFilledInline;

LinkedInFilledInline.default = LinkedInFilledInline;
